<app-list-header [headerName]="headerName"></app-list-header>
<app-lessons-list *ngIf="classId && subjectId"
  [lessonStatus]="lesson_completed"
  [studentClassId]="classId"
  [subjectId]="subjectId"
  [showHeader]="false"
  [onlyStatuses]="[lesson_completed]">
</app-lessons-list>
